


















import Enumerable from "linq";
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { IWizardPage } from "../../../../../domain/format";
import { ModelEditableMixin } from "../../../../system/mixins";
import { EditingDocument } from "../../EditingDocument";
import { SettingDialog } from "./dialogs";

@Component({
  components: {
    SettingDialog,
  }
})
export default class DocumentPageNavigator extends Mixins(ModelEditableMixin) {
  @Prop()
  document: EditingDocument;

  @Prop()
  pages: IWizardPage[];

  @Prop()
  isRegistered: boolean;

  @Prop()
  shouldAuthenticateOnRegistration: boolean;

  @Prop()
  unlock: () => Promise<boolean>;

  $refs!: {
    setting: SettingDialog,
  };

  data() {
    return {
      allowNoRequiredInputs: false,
      shouldSkipDisablePages: true,
    };
  }
  allowNoRequiredInputs: boolean;
  shouldSkipDisablePages: boolean;

  get pageNo(): number {
    return this.editingSource + 1;
  }

  get pageCount(): number {
    return this.pages.length;
  }

  get isEnable(): boolean {
    return (1 < this.pageCount);
  }

  get isRegisterable(): boolean {
    return this.isEnable
        && (this.allowNoRequiredInputs || this.pages[this.editingSource].isRegisterable(this.document.source));
  }

  get isMovableToPreviousPage(): boolean {
    return this.isEnable
        && (0 <= this.previousPageIndex);
  }

  get previousPageIndex(): number {
    return Enumerable.range(Math.max(this.editingSource - 1, 0), this.editingSource, -1)
      .firstOrDefault(i => !this.shouldSkipDisablePages || this.isPageEnable(i), -1);
  }

  get isMovableToNextPage(): boolean {
    return this.isRegisterable
        && (0 <= this.nextPageIndex);
  }

  get nextPageIndex(): number {
    return Enumerable.range(this.editingSource + 1, this.pageCount - this.editingSource - 1)
      .firstOrDefault(i => !this.shouldSkipDisablePages || this.isPageEnable(i), -1);
  }

  get isCurrentPageEnable(): boolean {
    return this.isPageEnable(this.editingSource);
  }

  get isCurrentPageRegisterable(): boolean {
    return this.isPageRegisterable(this.editingSource);
  }

  get lastUnregisterablePageIndex(): number {
    return Enumerable.range(0, this.pageCount)
      .firstOrDefault(i => !this.isPageRegisterable(i), this.pageCount - 1);
  }

  isPageIndexEnable(index: number): boolean {
    return (0 <= index)
        && (index < this.pages.length);
  }

  isPageEnable(index: number): boolean {
    return this.isPageIndexEnable(index)
        && this.pages[index].isEnable(this.document.source);
  }

  isPageRegisterable(index: number): boolean {
    return this.isPageIndexEnable(index)
        && this.pages[index].isRegisterable(this.document.source);
  }

  moveToPreviousPage(): void {
    if (this.isMovableToPreviousPage) {
      this.editingSource = this.previousPageIndex;
    }
  }

  moveToNextPage(): void {
    if (this.isMovableToNextPage) {
      this.editingSource = this.nextPageIndex;
    }
  }

  async showSetting(): Promise<void> {
    // 登録時認証されてるか管理権限認証できないと実行しない。(登録後で登録時に認証されてるなら認証できる人が操作してると判断。)
    if (!((this.shouldAuthenticateOnRegistration && this.isRegistered) || await this.unlock())) {
      return;
    }
    const result = await this.$refs.setting.show({
      allowNoRequiredInputs: this.allowNoRequiredInputs,
      shouldSkipDisablePages: this.shouldSkipDisablePages,
    });
    if (!!result) {
      if (this.shouldSkipDisablePages !== result.shouldSkipDisablePages) {
        this.shouldSkipDisablePages = result.shouldSkipDisablePages;
        if (this.shouldSkipDisablePages && !this.isCurrentPageEnable) {
          this.editingSource = this.isMovableToNextPage
            ? this.nextPageIndex
            : this.previousPageIndex;
        }
      }
      if (this.allowNoRequiredInputs !== result.allowNoRequiredInputs) {
        this.allowNoRequiredInputs = result.allowNoRequiredInputs;
        if (!this.allowNoRequiredInputs && (this.editingSource !== this.lastUnregisterablePageIndex)) {
          this.editingSource = this.lastUnregisterablePageIndex;
        }
      }
    }
  }

  @Watch("pages")
  onPagesChanged(newValue: IWizardPage[], oldValue: IWizardPage[]) {
    // Wizardは書き換えないのでinstanceが変わったということは編集→登録.
    if (oldValue === newValue) { return; }
    this.editingSource = 0;
  }
}
